import { sendGTMEvent } from "../gtmEvents";
import type { GTM } from "./GTMInterfaces";
import { buildGtmEventEcommerceFromServices } from "./buildGtmEventEcommerceFromServices";

export function sendGtmEventEcommerce(config: GTM.EventEcommerceFromServices) {
  const gtmEvent = buildGtmEventEcommerceFromServices(config);
  sendGTMEvent(gtmEvent);
}
